import 'moment/locale/nl';
import moment from 'moment';
import { isNumber } from 'lodash';

import {
    MOMENTJS_DATETIME_FORMAT,
    ERROR_TIMESTAMP_NOT_NUMBER,
    ERROR_DATE_NOT_VALID_MOMENTJS,
    ERROR_STRING_NULL
} from '../constants/moment';

/**
 * Convert timestamp to formatted date
 * @param timestamp in seconds from back (toEpochSecond)
 * @param format format in return (default: DD/MM/YYYY HH:mm:ss)
 * @returns {*}
 */
export function toDate(timestamp, format = MOMENTJS_DATETIME_FORMAT) {
    isTimestamp(timestamp);
    moment.locale('nl');
    return moment(timestamp * 1000).format(format);
}

export function nowTimestamp() {
    return moment().unix();
}

export function nowTimestampPlusHour(numberOrAdditionnalHours) {
    return moment()
        .add(numberOrAdditionnalHours, 'hours')
        .unix();
}

export function nowTimestampPlusDays(numberOrAdditionnalDays) {
    return timestampPlusDays(nowTimestamp(), numberOrAdditionnalDays);
}

export function nowTimestampMinusDays(days) {
    return timestampMinusDays(nowTimestamp(), days);
}

export function timestampPlusDays(timestamp, numberOrAdditionnalDays) {
    isTimestamp(timestamp);
    return toMoment(timestamp)
        .add(numberOrAdditionnalDays, 'days')
        .unix();
}

export function timestampMinusDays(timestamp, days) {
    isTimestamp(timestamp);
    return toMoment(timestamp)
        .subtract(days, 'days')
        .unix();
}

export function toTimestamp(date) {
    isMoment(date);
    return moment(date).unix();
}

export const isToday = date => {
    isMoment(date);
    const today = moment();
    return today.isSame(date, 'year') && today.isSame(date, 'month') && today.isSame(date, 'day');
};

/**
 * Convert a second timestamp in a moment object
 * @param {*Number} timestamp in seconds !
 */
export const toMoment = (timestamp = null) => {
    isTimestamp(timestamp);
    return moment.unix(timestamp);
};

export const isTimestamp = timestamp => {
    if (!timestamp || !isNumber(timestamp)) {
        throw new Error(ERROR_TIMESTAMP_NOT_NUMBER);
    }
};

export const isMoment = date => {
    if (!moment.isMoment(date)) {
        throw new Error(ERROR_DATE_NOT_VALID_MOMENTJS);
    }
};

export const stringToMoment = stringDate => {
    if (!stringDate) {
        throw new Error(ERROR_STRING_NULL);
    }
    return moment(stringDate);
};



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js